import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type RingState = {
  start: Date | undefined;
};

const initialState: RingState = {
  start: undefined,
};

const ringSlice = createSlice({
  name: "ring",
  initialState,
  reducers: {
    // Set the ring data
    setRing: (state, action: PayloadAction<RingState>) => {
      state.start = action.payload.start;
    },
    // Reset the ring data to initial state
    resetRing: () => initialState,
  },
});

export const { setRing, resetRing } = ringSlice.actions;

export default ringSlice.reducer;
